import React, { Component } from 'react';
import * as firebase from "firebase/app";
import { configureFacebook } from '../../../services/MetaService';
import { ValidatorForm, SelectValidator} from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import { firestore } from '../../../firebase-config';
import { app_facebook } from '../../../config/config_api';

class RevendaIntegracaoConfigurarFacebook extends Component {

    constructor (props){
        super(props);

        this.state = {
            idRevenda: "",
            status: 0,
            existeConfiguracao: false,
            dataAtual: null,
            paginas: [],
            isLoading: true,
            estaGravando: false,
            pagina: "",
            erro: "",
            autorizarAcessoEmpresarial: false
        }
        this.mounted = false;
        this.handleChange  = this.handleChange.bind(this);
        this.handleSubmit  = this.handleSubmit.bind(this);
    }

    componentDidMount(){

        this.state.dataAtual = firebase.firestore.FieldValue.serverTimestamp();

        const hash = window.location.hash;

        if(hash){

            const hashParams  = hash.substring(1);
            const paramsArray = hashParams.split('&');
            const token_data  = {};

            paramsArray.forEach(param => {
                const [key, value] = param.split('=');
                token_data[key] = value;
            });

            if(token_data.state && token_data.access_token && !token_data.error){

                token_data.status = parseInt(this.state.status) === 1 ? true : false;
                token_data.existeConfiguracao = this.state.existeConfiguracao;
                token_data.dataAtual = this.state.dataAtual;
                token_data.idRevenda = token_data.state;

                this.setState({ idRevenda: token_data.state });

                this.configureFacebook(token_data.idRevenda, token_data);
            } else {
                this.setState({ isLoading: false, erro: "A autorização do Facebook não foi concluída. Feche esta janela e inicie novamente a conexão pelo painel." });
            }

        } else {
            this.setState({ isLoading: false, erro: "Inicie a conexão com o Facebook pelo painel da revenda." });
        }         

    }
    
    configureFacebook = async (idRevenda, token_data) => {
        this.tokenData = token_data;
        this.setState({ isLoading: true, erro: "", autorizarAcessoEmpresarial: false });
        try {
            const response = await configureFacebook(idRevenda, token_data);
            if (response && response.status === "error"
                && ["facebook_page_selection_required", "facebook_page_not_authorized"].includes(response.code)
                && Array.isArray(response.paginas) && response.paginas.length > 0) {
                this.setState({ paginas: response.paginas, pagina: "", erro: response.data });
                return;
            }
            if (!response || response.status !== "success") {
                this.setState({
                    paginas: [],
                    autorizarAcessoEmpresarial: !!response && response.code === "facebook_business_permission_missing",
                    erro: response && typeof response.data === "string"
                        ? response.data : "Não foi possível configurar o Facebook. Tente novamente."
                });
                return;
            }
            const page = response.data;
            if (!page || !page.page_id || !page.page_name || !page.page_access_token) {
                this.setState({ erro: "A API não confirmou a vinculação da Página. Atualize a API e reconecte o Facebook." });
                return;
            }

            const user = JSON.parse(window.localStorage.getItem("usuarioLogado"));
            const integracao = {
                descricao: "Facebook",
                page_id: page.page_id,
                page_name: page.page_name,
                updated_id: user.id,
                updated_at: this.state.dataAtual,
                status: true
            };
            const doc = firestore.collection("revenda").doc(idRevenda).collection("integracoes").doc("facebook");
            const existing = await doc.get();
            if (!existing.exists) {
                integracao.created_id = user.id;
                integracao.created_at = this.state.dataAtual;
            }
            await doc.set(integracao, { merge: true });
            window.alert("Facebook configurado com sucesso!");
            window.close();
        } catch (error) {
            this.setState({ erro: "Não foi possível concluir a configuração no painel. Tente novamente." });
        } finally {
            this.setState({ isLoading: false, estaGravando: false });
        }
    }

    autorizarEmpresa = () => {
        // Solicitar acesso empresarial somente quando o diagnóstico indicar sua ausência.
        const params = new URLSearchParams({
            response_type: "token",
            display: "popup",
            client_id: app_facebook,
            redirect_uri: window.location.origin + "/integracao/configurar-facebook",
            auth_type: "rerequest",
            scope: "pages_show_list,pages_read_engagement,pages_manage_posts,business_management",
            state: this.state.idRevenda
        });
        window.location.assign("https://www.facebook.com/v20.0/dialog/oauth?" + params.toString());
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const selected = this.state.paginas[this.state.pagina];
        if (!selected || !selected.id) {
            this.setState({ erro: "Selecione a Página da revenda." });
            return;
        }
        this.setState({ estaGravando: true });
        this.configureFacebook(this.state.idRevenda, {
            ...this.tokenData,
            page_id: selected.id
        });
    }

    render(){    

        const { 
            isLoading, 
            paginas,
            estaGravando,
            pagina,
            erro,
            autorizarAcessoEmpresarial
        } = this.state;

        return (
            <div className="mt-5">
                { 
                    isLoading ? 

                    <div className="progress progress-upload-images progress-upload-images-integracao">
                        <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{ width: "100%" }}>Aguarde...</div>
                    </div>

                    : 
                
                    <div id="page-wrapper">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="panel panel-default">
                                    <div className="panel-heading">
                                        Selecionar página do Facebook
                                    </div>
                                    <div className="panel-body">
                                        {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
                                        {autorizarAcessoEmpresarial && (
                                            <button type="button" className="btn btn-primary" onClick={this.autorizarEmpresa}>
                                                Autorizar acesso empresarial
                                            </button>
                                        )}
                                        {paginas.length > 0 && <ValidatorForm
                                            ref="form"
                                            onSubmit={this.handleSubmit}
                                        >
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <SelectValidator
                                                            label="Página Facebook"
                                                            value={ pagina }
                                                            name="pagina"
                                                            className="form-ui-bootstrap"
                                                            onChange={this.handleChange}
                                                            validators={["required"]}
                                                            errorMessages={["Preenchimento obrigatório"]}
                                                            >
                                                                <MenuItem value="" ></MenuItem>

                                                                {
                                                                paginas.map((element, id) =>
                                                                    <MenuItem value={id} key={id}>{element.name}</MenuItem>                                                     
                                                                )
                                                            }
                                                        </SelectValidator>
                                                    </div>
                                                </div>
                                            </div>                                                                             
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <button type="submit" className="btn btn-primary" disabled={estaGravando || paginas.length === 0} >Gravar</button>
                                                </div>
                                            </div>
                                        </ValidatorForm>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }

}

export default RevendaIntegracaoConfigurarFacebook
